<template>
  <b-row class="nep-opt-main mb-4 p-0">
    <b-col
      cols="12"
      md="5"
      class="option-title house-pic"
      :style="{ backgroundImage: 'url(' + appRoot + estate.image + ')' }"
    >
      <div class="special2">
        <span style="font-weight: bold">{{ estate.location }}</span
        ><br />{{ estate.title }}
      </div>
      <div v-if="estate.tagID > 0" class="special-ban2">
        {{ getTagIDText(estate.tagID) }}
      </div>
      <div class="w-100 h-100" style="min-height: 10vw">
        <!-- <div style="margin-top:-1.5vw;font-size: clamp(1rem, 1vw + 0.1rem, 3rem);text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;text-align:left;">{{ estate.title }}<br>{{ estate.location }}</div> -->
      </div>
    </b-col>
    <b-col
      cols="12"
      md="7"
      class="mt-3 mb-1 options-text"
      style="position: relative; font-size: 0.9vw; text-align: left"
    >
      <b-row>
        <b-col cols="12" class="fluid-text" v-html="estate.description"></b-col>
      </b-row>
      <b-row class="text-left mt-3 fluid-text nep-article-texts mb-5">
        <b-col offset="4" cols="8"
          ><div class="nep-article-data">{{ $t('construction-year') }}:</div>
          <div class="nep-article-data text-right">
            <b>{{ estate.build }}</b>
          </div></b-col
        >
        <b-col offset="4" cols="8"
          ><div class="nep-article-data">{{ $t('size') }}:</div>
          <div class="nep-article-data text-right">
            <b>{{ estate.area }} m<sup>2</sup></b>
          </div></b-col
        >
        <b-col offset="4" cols="8"
          ><div class="nep-article-data">{{ $t('price-tag') }}:</div>
          <div class="nep-article-data text-right" style="color: red">
            <b>{{ estate.priceTag }}</b>
          </div></b-col
        >
      </b-row>
      <a :href="estate.link" target="_blank">
        <div class="breathing fluid-text btn-more mt-4 mb-2" style="position:absolute;bottom:0;right:6px;font-weight:bold;">{{ $t('more') }}</div>
      </a>
    </b-col>
  </b-row>
</template>
<style scoped>
  .special, .special2 {
    color: #fff;
    font-weight: bold;
    font-style: italic;
    padding: 4px;
  }
  .special2 {
    background-color: #1d91b7bb;
    position: absolute;
    bottom: 10px;
    left: 0;
    margin: 0 0 0 10px;
    padding: 0 10px;
  }
  .special-ban, .special-ban2 {
    color: #fff;
    font-weight: bold;
    font-style: italic;
    padding: 4px;
  }
  .special-ban2 {
    background-color: #9C1B21;
    position: absolute;
    top: 5px;
    right: 0;
    margin: 10px 0 0 0;
    padding: 0 10px;
  }

/*
  div.nep-banner {
    height: 1vw;
    width: 11vw;
    background-color: #9C1B21;
    position: absolute;
    top: 3vw;
    right: -7px;
    text-align: center;
    color: #FFF;
    font-weight: 600;
    font-size: 0.8vw;
    white-space: nowrap;
    -webkit-transform: rotate(35deg);
    -moz-transform: rotate(35deg);
    -ms-transform: rotate(35deg);
    -o-transform: rotate(35deg);
    transform: rotate(35deg);
  }
  .nep-banner:before {
    box-sizing: border-box;
    border-style: solid;
    border-color: transparent;
    border-width: 1.2vw;
    border-left-width: 1.5vw;
    border-right-width: .8vw;
    content: "";
    display: block;
    left: -3.2vw;
    position: absolute;
    width: 141%;
    border-top-width: 0px;
    border-bottom-color: #9c1b21;
    top: -2px;
    z-index: -1;
  }
  @media only screen and (max-width: 1400px) {
    div.nep-banner {
      height: 2vw;
      width: 22vw;
      background-color: #9C1B21;
      position: absolute;
      top: 6vw;
      right: -0.9vw;
      text-align: center;
      color: #FFF;
      font-weight: 600;
      font-size: 1.6vw;
      white-space: nowrap;
      -webkit-transform: rotate(35deg);
      -moz-transform: rotate(35deg);
      -ms-transform: rotate(35deg);
      -o-transform: rotate(35deg);
      transform: rotate(35deg);
    }
    .nep-banner:before {
      box-sizing: border-box;
      border-style: solid;
      border-color: transparent;
      border-width: 2.4vw;
      border-left-width: 3vw;
      border-right-width: 1.6vw;
      content: "";
      display: block;
      left: -6.9vw;
      position: absolute;
      width: 141%;
      border-top-width: 0px;
      border-bottom-color: #9c1b21;
      top: -2px;
      z-index: -1;
    }
  }
  @media only screen and (max-width: 768px) {
    div.nep-banner {
      height: 3vw;
      width: 33vw;
      background-color: #9C1B21;
      position: absolute;
      top: 9vw;
      right: -7px;
      text-align: center;
      color: #FFF;
      font-weight: 600;
      font-size: 2.4vw;
      white-space: nowrap;
      -webkit-transform: rotate(35deg);
      -moz-transform: rotate(35deg);
      -ms-transform: rotate(35deg);
      -o-transform: rotate(35deg);
      transform: rotate(35deg);
    }
    .nep-banner:before {
      box-sizing: border-box;
      border-style: solid;
      border-color: transparent;
      border-width: 3.6vw;
      border-left-width: 4.5vw;
      border-right-width: 2.4vw;
      content: "";
      display: block;
      left: -9.6vw;
      position: absolute;
      width: 141%;
      border-top-width: 0px;
      border-bottom-color: #9c1b21;
      top: -2px;
      z-index: -1;
    }
  }
*/
</style>
<script>
import { mapState } from 'vuex'
export default {
  name: "homeArticle",
  props: {
    value: null,
    estate: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      tags: [
        { id: 0, text: '' },
        { id: 1, text: this.$t('new') },
        { id: 2, text: this.$t('agreed') },
        { id: 3, text: this.$t('sold') },
      ],
    };
  },
  methods: {
    getTagIDText(tagId) {
      let elem = this.tags.find((el) => el.id === tagId);
      return elem.text;
    },
  },
  mounted() {
    // if (!this.userSelect && this.users.length === 1) {
    //   this.value.selectedUserId = this.users[0].id
    // }
  },
  computed: {
    ...mapState({
        appRoot: state => state.app_root
    //   appWidth: state => state.appWidth,
    //   userData: state => state.userData,
    //   entryTypes: state => [{ id: null, text: '' }, ...state.entryTypes],
    //   tsTypes: state => [{ id: null, text: '' }, ...state.tsTypes],
    //   holidays: state => state.holidays,
    //   localeData: state => state.localeData,
    //   isAdmin: state => (state.userData.isAdmin === 1)
    })
  },
};
</script>
<i18n>
  {
    "sl": {
      "construction-year": "Leto gradnje",
      "size": "Velikost",
      "price-tag": "Cena",
      "more": "VEČ O PONUDBI",
      "new": "NOVO",
      "agreed": "DOGOVORJEN POSEL",
      "sold": "PRODANO"
      },
    "de": {
      "construction-year": "Baujahr",
      "size": "Größe",
      "price-tag": "Preis",
      "more": "MEHR...",
      "new": "NEU",
      "agreed": "VEREINBARTER ANGEBOT",
      "sold": "VERKAUFT"
    },
    "en": {
      "construction-year": "Build year",
      "size": "Size",
      "price-tag": "Price",
      "more": "MORE...",
      "new": "NEW",
      "agreed": "AGREED DEAL",
      "sold": "SOLD"
    }
  }
  </i18n>
  